import { Component, EventEmitter, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-template-confirmation-modal',
  templateUrl: './template-confirmation-modal.component.pug',
  styleUrls: ['./template-confirmation-modal.component.scss'],
  standalone: false
})
export class TemplateConfirmationModalComponent implements OnInit {
  confirmClick: EventEmitter<any> = new EventEmitter();
  
  title: string = '';
  message: string = '';
  confirmButtonText: string = '';
  templateName: string = '';

  constructor(
    public bsModalRef: BsModalRef,
  ) {
  }

  ngOnInit(): void {
    // Initial state properties are set directly on the component instance by ngx-bootstrap modal service
    // The properties (title, message, confirmButtonText, templateName) are set automatically
  }

  confirm(): void {
    this.confirmClick.emit();
    this.bsModalRef.hide();
  }

  cancel(): void {
    this.bsModalRef.hide();
  }
}

